import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=06befb91&scoped=true&"
import script from "./Features.vue?vue&type=script&lang=js&"
export * from "./Features.vue?vue&type=script&lang=js&"
import style0 from "./Features.vue?vue&type=style&index=0&id=06befb91&prod&lang=scss&"
import style1 from "./Features.vue?vue&type=style&index=1&id=06befb91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06befb91",
  null
  
)

export default component.exports